// Import the country codes JSON file
import countryCodes from "../components/data/CountryCodes.json";

/**
 * Get the flag URL based on the provided country name.
 * @param {string} countryName - The name of the country.
 * @param {string} style - The style of the flag ('flat' or 'shiny').
 * @param {number} size - The size of the flag (16, 32, 64, 128).
 * @returns {string|null} - The URL of the flag or null if not found.
 */
export function getFlagByCountryName(countryName, style = "flat", size = 64) {
  // Find the country object by name (case-insensitive)
  const country = countryCodes.find(
    (c) => c.name.toLowerCase() === countryName.toLowerCase()
  );

  // If the country is found, generate the flag URL
  if (country && country.code) {
    return `https://flagsapi.com/${country.code}/${style}/${size}.png`;
  }

  // Return null if the country is not found
  console.warn(`No flag found for country: ${countryName}`);
  return null;
}


export function getFlagByCountryCode(countryCode, style = "flat", size = 64) {  // Changed to countryCode
    if (!countryCode) return "https://via.placeholder.com/32?text=🏳️";
    const flagUrl = `https://flagsapi.com/${countryCode}/${style}/${size}.png`; // Directly use code
    //console.log("Flag URL:", flagUrl);
    //console.log("getFlagByCountryCode - Country Code:", countryCode); // Log the input code
    //console.log("getFlagByCountryCode - Generated URL:", flagUrl); // Log the generated URL
    return flagUrl;
  }